module.exports = __webpack_public_path__ + "img/Liefern_anywhere_2.d36ee626.png";